import Vue from 'vue'

import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
// import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
// import 'vxe-table/lib/style.css'
// import 'vxe-table-plugin-element/dist/style.css'

import './components'

VXETable.use(VXETablePluginElement)
// VXETable.use(VXETablePluginExportXLSX)
Vue.use(VXETable)

Vue.prototype.$msgSuccess = function (msg) {
  // this.$message({ showClose: true, message: msg || '操作成功', type: 'success' })
  VXETable.modal.message({ message: msg, status: 'success', zIndex: 99999 })
}

Vue.prototype.$msgWarning = function (msg) {
  // this.$message.info(msg)
  VXETable.modal.message({ message: msg, status: 'warning', zIndex: 99999 })
}

Vue.prototype.$msgError = function (msg) {
  // this.$message({ showClose: true, message: msg || '操作失败', type: 'error' })
  VXETable.modal.message({ message: msg, status: 'error', zIndex: 99999 })
}

Vue.prototype.$msgInfo = function (msg) {
  // this.$message.info(msg)
  VXETable.modal.message({ message: msg, status: 'info', zIndex: 99999 })
}

Array.prototype.find = function (key, val) {
  for (const item of this) {
    if (item[key] === val) {
      return item
    }
  }
}
